import type { ReferenceProps, ReferenceSlots, ReferenceState } from './Reference';
import {
  Reference,
  referenceClassNames,
  referenceExtraClassNames,
  renderReference_unstable,
  useReferenceStyles_unstable,
  useReference_unstable,
} from './Reference';
import type {
  ReferenceListContextValues,
  ReferenceListProps,
  ReferenceListSlots,
  ReferenceListState,
} from './ReferenceList';
import {
  ReferenceList,
  referenceListClassNames,
  renderReferenceList_unstable,
  useReferenceListStyles_unstable,
  useReferenceList_unstable,
} from './ReferenceList';
import type {
  PackagedCitation,
  PackagedPreviewContentProps,
  PackagedReference,
  ReferenceCitationPreviewGenerator,
  ReferenceCitationPreviewGeneratorProps,
  UseReferenceCitationPreview,
  UseReferenceCitationPreviewProps,
} from './utilities';
import { generateReferenceCitationPreview, useReferenceCitationPreview } from './utilities';

export type { CitationSlots, CitationProps, CitationState } from './Citation';
export {
  Citation,
  citationClassNames,
  renderCitation_unstable,
  useCitation_unstable,
  useCitationStyles_unstable,
} from './Citation';

/** @deprecated use ReferenceProps */
type ReferenceV2Props = ReferenceProps;
/** @deprecated use ReferenceSlots */
type ReferenceV2Slots = ReferenceSlots;
/** @deprecated use ReferenceState */
type ReferenceV2State = ReferenceState;

/** @deprecated use Reference */
const ReferenceV2 = Reference;
/** @deprecated use referenceClassNames */
const referenceV2ClassNames = referenceClassNames;
/** @deprecated use referenceExtraClassNames */
const referenceV2ExtraClassNames = referenceExtraClassNames;
/** @deprecated use renderReference_unstable */
const renderReferenceV2_unstable = renderReference_unstable;
/** @deprecated use useReferenceStyles_unstable */
const useReferenceV2Styles_unstable = useReferenceStyles_unstable;
/** @deprecated use useReference_unstable */
const useReferenceV2_unstable = useReference_unstable;

// reference-v2 exports
export type { ReferenceProps, ReferenceV2Props, ReferenceSlots, ReferenceV2Slots, ReferenceState, ReferenceV2State };
export {
  Reference,
  ReferenceV2,
  referenceClassNames,
  referenceV2ClassNames,
  referenceExtraClassNames,
  referenceV2ExtraClassNames,
  renderReference_unstable,
  renderReferenceV2_unstable,
  useReferenceStyles_unstable,
  useReferenceV2Styles_unstable,
  useReference_unstable,
  useReferenceV2_unstable,
};

/** @deprecated use ReferenceListContextValues */
type ReferenceListV2ContextValues = ReferenceListContextValues;
/** @deprecated use ReferenceListProps */
type ReferenceListV2Props = ReferenceListProps;
/** @deprecated use ReferenceListSlots */
type ReferenceListV2Slots = ReferenceListSlots;
/** @deprecated use ReferenceListState */
type ReferenceListV2State = ReferenceListState;

/** @deprecated use ReferenceList */
const ReferenceListV2 = ReferenceList;
/** @deprecated use referenceListClassNames */
const referenceListV2ClassNames = referenceListClassNames;
/** @deprecated use renderReferenceList_unstable */
const renderReferenceListV2_unstable = renderReferenceList_unstable;
/** @deprecated use useReferenceListStyles_unstable */
const useReferenceListV2Styles_unstable = useReferenceListStyles_unstable;
/** @deprecated use useReferenceList_unstable */
const useReferenceListV2_unstable = useReferenceList_unstable;

export type {
  ReferenceListContextValues,
  ReferenceListV2ContextValues,
  ReferenceListProps,
  ReferenceListV2Props,
  ReferenceListSlots,
  ReferenceListV2Slots,
  ReferenceListState,
  ReferenceListV2State,
};
export {
  ReferenceList,
  ReferenceListV2,
  referenceListClassNames,
  referenceListV2ClassNames,
  renderReferenceList_unstable,
  renderReferenceListV2_unstable,
  useReferenceListStyles_unstable,
  useReferenceListV2Styles_unstable,
  useReferenceList_unstable,
  useReferenceListV2_unstable,
};

export type {
  ReferenceOverflowButtonProps,
  ReferenceOverflowButtonSlots,
  ReferenceOverflowButtonState,
} from './ReferenceOverflowButton';
export {
  ReferenceOverflowButton,
  referenceOverflowButtonClassNames,
  renderReferenceOverflowButton_unstable,
  useReferenceOverflowButtonStyles_unstable,
  useReferenceOverflowButton_unstable,
} from './ReferenceOverflowButton';

export type { ReferenceListContextValue } from './contexts';
export { ReferenceListContext, ReferenceListContextProvider, useReferenceListContext_unstable } from './contexts';

/** @deprecated use PackagedCitation */
type PackagedCitationV2 = PackagedCitation;
/** @deprecated use PackagedPreviewContentProps */
type PackagedPreviewContentV2Props = PackagedPreviewContentProps;
/** @deprecated use PackagedReference */
type PackagedReferenceV2 = PackagedReference;
/** @deprecated use UseReferenceCitationPreview */
type UseReferenceCitationPreviewV2 = UseReferenceCitationPreview;
/** @deprecated use UseReferenceCitationPreviewProps */
type UseReferenceCitationPreviewV2Props = UseReferenceCitationPreviewProps;

/** @deprecated use useReferenceCitationPreview */
const useReferenceCitationPreviewV2 = useReferenceCitationPreview;

export type {
  PackagedCitation,
  PackagedCitationV2,
  PackagedPreviewContentProps,
  PackagedPreviewContentV2Props,
  PackagedReference,
  PackagedReferenceV2,
  ReferenceCitationPreviewGenerator,
  ReferenceCitationPreviewGeneratorProps,
  UseReferenceCitationPreview,
  UseReferenceCitationPreviewV2,
  UseReferenceCitationPreviewProps,
  UseReferenceCitationPreviewV2Props,
};
export { generateReferenceCitationPreview, useReferenceCitationPreview, useReferenceCitationPreviewV2 };
